import { useAtom } from '@reatom/npm-react'

import { WalletsAssetsCell } from '@root/entities/wallet/ui/table/column/wallets-assets-cell'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
  onExpandToggle: () => void
  expanded: boolean
}

export const WalletsTableAssetsCell: React.FC<Props> = ({
  wallet,
  onExpandToggle,
  expanded,
}) => {
  const [assets] = useAtom(wallet.assets)

  return (
    <WalletsAssetsCell
      assetsNumber={assets.length}
      onExpandToggle={onExpandToggle}
      expanded={expanded}
    />
  )
}
